import { createRouter, createWebHistory } from 'vue-router'

import Map from '@/views/Map.vue'
import Backend from '@/views/Backend.vue'
import LanguageList from '@/views/LanguageList.vue'
import DialectList from '@/views/DialectList.vue'
import SubDialectList from '@/views/SubDialectList.vue'
import AccentList from '@/views/AccentList.vue'
import LoginView from "@/views/LoginView.vue";
import RegistetView from "@/views/RegistetView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import ModifyInfoView from "@/views/ModifyInfoView.vue";
import ChangePwdView from "@/views/ChangePwdView.vue";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginView,
    },
    {
        path: '/forgot',
        name: 'Forgot',
        component: ForgotPasswordView,
    },
    {
        path:'/changeInfo',
        name:"ChangeInfo",
        component: ModifyInfoView
    },
    {
        path:'/changePwd',
        name:"ChangePwd",
        component: ChangePwdView
    },
    {
        path: '/register',
        name: 'Register',
        component: RegistetView,
    },
    {
        path: '/',
        name: 'Map',
        component: Map,
        meta: { requiresAuth: true }
    },

    {
        path: '/backend',
        name: 'Backend',
        component: Backend,
        meta: { requiresAuth: true }
    },
    {
        path: '/languages',
        name: 'LanguageList',
        component: LanguageList,
        meta: { requiresAuth: true }
    },
    {
        path: '/dialects/:id?',   // 动态路由
        name: 'DialectList',
        component: DialectList,
        props: true,
        meta: { requiresAuth: true }
    }
    ,
    {
        path: '/subdialects/:id?',   // 动态路由
        name: 'SubDialectList',
        component: SubDialectList,
        props: true,
        meta: { requiresAuth: true }
    }
    ,
    {
        path: '/accents/:id?',   // 动态路由
        name: 'AccentList',
        component: AccentList,
        props: true,
        meta: { requiresAuth: true }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem("token")
    if (to.meta.requiresAuth && !token) {
        next('/login')
    } else {
        next()
    }
})

export default router